var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveOffersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5502 10.9494L11.6752 3.07439C11.3602 2.75939 10.9227 2.56689 10.4414 2.56689H4.31641C3.35391 2.56689 2.56641 3.35439 2.56641 4.31689V10.4419C2.56641 10.9231 2.75891 11.3606 3.08266 11.6844L10.9577 19.5594C11.2727 19.8744 11.7102 20.0669 12.1914 20.0669C12.6727 20.0669 13.1102 19.8744 13.4252 19.5506L19.5502 13.4256C19.8739 13.1106 20.0664 12.6731 20.0664 12.1919C20.0664 11.7106 19.8652 11.2644 19.5502 10.9494ZM5.62891 6.94189C4.90266 6.94189 4.31641 6.35564 4.31641 5.62939C4.31641 4.90314 4.90266 4.31689 5.62891 4.31689C6.35516 4.31689 6.94141 4.90314 6.94141 5.62939C6.94141 6.35564 6.35516 6.94189 5.62891 6.94189Z",
    fill: "#178EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveOffersIcon);
export default __webpack_public_path__ + "static/media/active-offers-icon.42181b7025f5f938e8111830d973dd5e.svg";
export { ForwardRef as ReactComponent };